import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StringService {
    constructor() {}

    wrapAsArray(str: string): string {
        if (str.charAt(0) !== '[') {
            str = '[' + str;
        }

        if (str.charAt(str.length) !== ']') {
            str = str + ']';
        }

        return str;
    }

    removeBrackets(str: string): string {
        if (str.charAt(0) === '[') {
            str = str.substring(1);
        }

        if (str.charAt(str.length - 1) === ']') {
            str = str.substring(0, str.length - 1);
        }
        return str;
    }

    isJson(str: string): boolean {
        try {
            return JSON.parse(str) && str;
        } catch (e) {
            return false;
        }
    }

    getCurrentDate(): string {
        let today = new Date();
        const dd = today.getDate();

        const mm = today.getMonth() + 1;
        const yyyy = today.getFullYear();

        return mm + '/' + dd + '/' + yyyy;
    }

    getBirthDateISO(): string {
        const bd = new Date();
        bd.setFullYear(bd.getFullYear() - 30);
        return bd.toISOString();
    }

    getCurrentDateISO(): string {
        return new Date().toISOString();
    }
}
